// JS
import '../../custom/js/index';

// Base SCSS
import '../../custom/scss/base.scss';
import '../../custom/scss/layout.scss';
import '../../custom/scss/components/location-finder/location-finder.scss';
import '../../custom/scss/components/cta/cta.scss';
import '../../custom/scss/components/breadcrumb/breadcrumb.scss';
import '../../custom/scss/components/pagination/pagination.scss';


// import Vue App
import Vue from 'vue';
import VueApp from '../../custom/vue/custom-apps/map-filter';
import App from '../../custom/vue/custom-apps/containers/map-filter.vue';

// connect vue component and init app
Vue.component('app', App);
VueApp.$mount('#filter-app');